import { Container } from '@mui/material';

const Header = () => (
  <Container sx={{ padding: '20px 20px 0 20px', maxWidth: '700px' }}>
    <a href="https://fotballyst.no/">
      <img
        style={{ width: '100%', maxWidth: '350px' }}
        src="https://firebasestorage.googleapis.com/v0/b/fotballyst.appspot.com/o/logo2022.png?alt=media&token=a921d492-e9c4-41f1-bb81-966b3a26718e"
        alt="Fotballyst logo"
      />
    </a>
  </Container>
);

export default Header;
